import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, formatGraphqlParams } from '@/utils'

export default {
  fetch(data = {}) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

    const params = formatGraphqlParams({
      tag: data.tag,
      from_mutation: data.from_mutation || false
    });

    return axios.post('', formatGraphqlBody(
      'query',
      'messages',
      {
        0: 'id',
        1: 'name',
        2: 'value',
        3: 'options',
        4: 'number',
        5: 'parent_id',
        6: 'from_mutation',
        scale: {
          0: 'start',
          1: 'end'
        }
      },
      params
    ))
  },
  add(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      tag: data.tag,
      name: data.name,
      scale: [data.scale],
      parent_id: data.parent_id,
      value: `""${(data.value)}""`,
      number: `${(data.number || '')}`
    });

    return axios.post('', formatGraphqlBody(
      'mutation',
      'createMessage',
      {
        0: 'id',
        1: 'name',
        2: 'value',
        3: 'number',
        4: 'options',
        5: 'parent_id',
        6: 'from_mutation',
        scale: {
          0: 'start',
          1: 'end'
        }
      },
      params
    ))
  },
  update(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    const params = formatGraphqlParams({
      id: data.id,
      name: data.name,
      scale: [data.scale],
      value: `""${(data.value)}""`,
      number: `${(data.number || '')}`
    });

    return axios.post('', formatGraphqlBody(
      'mutation',
      'updateMessage',
      {
        0: 'id',
        1: 'name',
        2: 'value',
        3: 'number',
        4: 'options',
        5: 'parent_id',
        6: 'from_mutation',
        scale: {
          0: 'start',
          1: 'end'
        }
      },
      params
    ))
  },
  delete(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'

    const params = formatGraphqlParams({id: id});
    return axios.post('', formatGraphqlBody(
      'mutation',
      'deleteMessage',
      null,
      params
    ))
  },
}
